import { useTranslation } from "react-i18next";

import { cap } from "../../../utils/utils";

const InputText = ({ type, name, label, placeholder, value, onChange, required, error }) => {
  const { t } = useTranslation();

  return (
    <div className={`lineInput lineInput${type} lineInput${cap(name)} ${error ? "invalid" : ""}`}>
      {label && <label htmlFor={name}>{t(label.toUpperCase())}</label>}
      {required && <span>{t("REQUIRED_FIELD")}</span>}
      <input type="text" name={name} placeholder={t(placeholder)} value={value} onChange={(e) => onChange(e, name)} />
    </div>
  );
};

export default InputText;
